<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <h1>Контакты</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="block_flex" v-if="isLoaded">
          <div class="left">
            <div class="folder radius">
              <div class="column caption">
                <p>Страница контактов</p>
              </div>
              <div class="column">
                <div class="content">
                  <new-input title="Имя" name="name_contacts"></new-input>
                  <new-input title="Должность" name="position_contacts"></new-input>
                  <edit-file class="short align-top" use-case="cover" title="Фото"
                             name="img_contacts"></edit-file>
                  <new-input title="Alt для фото" name="alt_contacts"></new-input>
                  <new-input title="Email" name="email_contacts"></new-input>
                  <new-input title="Skype" name="skype_contacts"></new-input>
                  <new-input title="YouTube" name="yt_contacts"></new-input>
                  <new-input title="Pinterest" name="pinterest_contacts"></new-input>
                  <new-input title="Facebook" name="fb_contacts"></new-input>
                  <new-input title="Одноклассники" name="ok_contacts"></new-input>
                  <new-input title="LiveJournal" name="lj_contacts"></new-input>
                  <new-input title="Вконтакте" name="vk_contacts"></new-input>
                </div>
              </div>

            </div>
          </div>
          <div class="right">
            <div class="folder radius">
              <div class="column caption">
                <p>Футер</p>
              </div>
              <div class="column">
                <div class="content">
                  <new-input title="Email" name="email_footer"></new-input>
                  <new-input title="Skype" name="skype_footer"></new-input>
                  <new-input title="YouTube" name="yt_footer"></new-input>
                  <new-input title="Telegram" name="telegram_footer"></new-input>
                  <new-input title="Facebook" name="fb_footer"></new-input>
                  <new-input title="Одноклассники" name="ok_footer"></new-input>
                  <new-input title="LiveJournal" name="lj_footer"></new-input>
                  <new-input title="Вконтакте" name="vk_footer"></new-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import Calendar from '@/components/edit-form/Calendar'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'
  import Checkbox from "@/components/edit-form/Checkbox";
  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')



  export default {
    data: function () {
      return {
        isLoaded: false,
        editorInstance: '',
        text: '',
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent',
        'errors'
      ]),
      apiUrls() {
        return this.$store.state.apiUrls
      },
      parentId() {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset',
      ]),
      ...mapMutations([
        'resetModule',
        'setFileExtensions',
        'setItemField',
        'setErrors'
      ]),
      onSubmit() {
        let object = {
          name_contacts: this.item.name_contacts,
          position_contacts: this.item.position_contacts,
          img_contacts: this.item.img_contacts,
          alt_contacts: this.item.alt_contacts,
          email_contacts: this.item.email_contacts,
          skype_contacts: this.item.skype_contacts,
          yt_contacts: this.item.yt_contacts,
          pinterest_contacts: this.item.pinterest_contacts,
          fb_contacts: this.item.fb_contacts,
          ok_contacts: this.item.ok_contacts,
          lj_contacts: this.item.lj_contacts,
          vk_contacts: this.item.vk_contacts,
          email_footer: this.item.email_footer,
          skype_footer: this.item.skype_footer,
          yt_footer: this.item.yt_footer,
          telegram_footer: this.item.telegram_footer,
          fb_footer: this.item.fb_footer,
          ok_footer: this.item.ok_footer,
          lj_footer: this.item.lj_footer,
          vk_footer: this.item.vk_footer,
        }
        this.edit({
          object: JSON.stringify(object)
        })
      }
    },
    created() {
      this.resetModule();
      this.setFileExtensions({img_contacts: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование книги',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          name_contacts: {hasError: false, isNullable: true},
          position_contacts: {hasError: false, isNullable: true},
          img_contacts: {hasError: false, isNullable: true},
          alt_contacts: {hasError: false, isNullable: true},
          email_contacts: {hasError: false, isNullable: true},
          skype_contacts: {hasError: false, isNullable: true},
          yt_contacts: {hasError: false, isNullable: true},
          pinterest_contacts: {hasError: false, isNullable: true},
          fb_contacts: {hasError: false, isNullable: true},
          ok_contacts: {hasError: false, isNullable: true},
          lj_contacts: {hasError: false, isNullable: true},
          vk_contacts: {hasError: false, isNullable: true},
          email_footer: {hasError: false, isNullable: true},
          skype_footer: {hasError: false, isNullable: true},
          yt_footer: {hasError: false, isNullable: true},
          telegram_footer: {hasError: false, isNullable: true},
          fb_footer: {hasError: false, isNullable: true},
          ok_footer: {hasError: false, isNullable: true},
          lj_footer: {hasError: false, isNullable: true},
          vk_footer: {hasError: false, isNullable: true},
        },
        itemId: this.parentId.settings,
        apiUrl: this.apiUrls.content
      }).then(response => {
        this.text = response.text ? response.text : '';
        for (let key in response.object) {
          if (response.object.hasOwnProperty(key)) {
            this.setItemField({fieldName: key, value: response.object[key]});
          }
        }
        this.isLoaded = true;
      })
    },
    components: {
      Checkbox,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload,
      Calendar,
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/contacts/Index.vue